import _Field from "redux-form/es/Field";
import React from 'react';
import { UnderlinedPasswordInput } from 'swag-client-common/components/inputs/password-input';
import PasswordRequirementsBlock from 'swag-client-common/components/info/password-requirements-block';
import { required, password as passwordValidator } from 'swag-client-common/utils/redux-form-validators';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import { Button } from '../../ui/button';
import { TosCheckbox } from '../tos-checkbox';
import { modeEnum } from './set-password-form.interfaces';
import classes from './set-password-form.scss';
const ResetPassForm = ({
  errorMessage,
  handleSubmit,
  onSubmit,
  mode,
  isError,
  isLoading,
  requireApproveTerms,
  password,
  completedPasswordRequirements,
  isAllPasswordRequirementsCompleted,
  isPasswordLengthMoreThanMaxAllowedCharacters,
  isPasswordInputFocused,
  invalid
}) => {
  let label;
  switch (mode) {
    case modeEnum.setPassword:
      label = 'Enter your password';
      break;
    case modeEnum.forgotPassword:
    default:
      label = 'Enter your new password';
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: classes.title
  }, "Set your new password!"), isError && /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, errorMessage), /*#__PURE__*/React.createElement("form", {
    className: utilClasses.textCenter,
    onSubmit: handleSubmit && handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(_Field, {
    name: "password",
    component: UnderlinedPasswordInput,
    isAllPasswordRequirementsCompleted: isAllPasswordRequirementsCompleted,
    type: "password",
    validate: [required, passwordValidator],
    label: label,
    errorClassName: password ? classes.strengthInputErrorClassName : classes.errorClassName
  }), /*#__PURE__*/React.createElement(PasswordRequirementsBlock, {
    isLengthMoreThanMaxAllowedCharacters: isPasswordLengthMoreThanMaxAllowedCharacters,
    isAllRequirementsCompleted: isAllPasswordRequirementsCompleted,
    completedRequirements: completedPasswordRequirements,
    isInputFocused: isPasswordInputFocused
  }), !!requireApproveTerms && /*#__PURE__*/React.createElement(TosCheckbox, {
    isFixedStyling: true,
    buttonName: "Submit",
    tosCheckboxWrapperClassName: classes.resetPassWrapper
  }), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    size: "small",
    loading: isLoading,
    disabled: invalid,
    className: classes.submitButton
  }, "Submit")));
};
export default ResetPassForm;